import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';
import { StatusEnum } from '../../../enums/status';
import { useTranslation } from 'react-i18next';

interface Props {
  value: StatusEnum,
  onChange: (newValue: StatusEnum) => void
}

export default function TabPanelActiveComponent({ value, onChange }: Props) {
  const { t } = useTranslation('global');

  return (
    <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR  }}>
      <Box sx={{  borderColor: 'divider' }}>
        <Tabs value={value} onChange={(e: any, newValue: StatusEnum) => {
          onChange(newValue);
        }} variant="scrollable"
          scrollButtons="auto">
          <Tab label={t("customer_page.All")} value={StatusEnum.ALL} sx={{ textTransform: 'none' }} />
          <Tab label={t("customer_page.Active")} value={StatusEnum.ACTIVE} sx={{ textTransform: 'none' }} />
          <Tab label={t("customer_page.InActive")} value={StatusEnum.INACTIVE} sx={{ textTransform: 'none' }} />
        </Tabs>
      </Box>
    </Box>
  );
}
